import { render } from "./AppTopbar.vue?vue&type=template&id=9a061484"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"
script.render = render

export default script